import {
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILURE,
  GET_CATALOG,
  GET_CATALOG_SUCCESS,
  GET_CATALOG_FAILURE,
  RESET_RBAC,
} from "../constants/Rbac";

export const GetRoles = (data) => ({ type: GET_ROLES, payload: data });
export const GetRolesSuccess = (payload) => ({ type: GET_ROLES_SUCCESS, payload });
export const GetRolesFailure = (payload) => ({ type: GET_ROLES_FAILURE, payload });
export const GetCatalog = (data) => ({ type: GET_CATALOG, payload: data });
export const GetCatalogSuccess = (payload) => ({ type: GET_CATALOG_SUCCESS, payload });
export const GetCatalogFailure = (payload) => ({ type: GET_CATALOG_FAILURE, payload });
export const ResetRbac = () => ({ type: RESET_RBAC });
